
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-stroke",attrs:{"d":"M7 4h8M7 9h8M7 14h8"}}),_c('path',{staticClass:"ql-stroke ql-thin",attrs:{"d":"M2.5 5.5h2"}}),_c('path',{staticClass:"ql-fill",attrs:{"d":"M3.5 6a.5.5 0 01-.5-.5V3.085l-.276.138A.5.5 0 012.053 3c-.124-.247-.023-.324.224-.447l1-.5A.5.5 0 014 2.5v3a.5.5 0 01-.5.5z"}}),_c('path',{staticClass:"ql-stroke ql-thin",attrs:{"d":"M4.5 10.5h-2c0-.234 1.85-1.076 1.85-2.234a.959.959 0 00-1.85-.11M2.5 14.846a.959.959 0 001.85-.109.7.7 0 00-.6-.737.688.688 0 00.6-.736.959.959 0 00-1.85-.109"}})])
          )
        }
      }
    